<template>
    <div class="grid-column">
        <slot></slot>
    </div>
</template>
